export enum ForgotPasswordErrorEnum {
  OTP = 1089,
  NID = 1055,
  OTP_DUPLICATE = 16002,
  BLOCK = 1130,
}
